module.exports = __webpack_public_path__ + "static/img/ntradition_img02.0baef7ec.png";